import React from 'react';
import { Select, SelectOption } from 'src/components/general/inputs/select/select';
import { useAiAgentsListForSelect } from 'src/components/pages/ai-agents/analytics/hooks/use-ai-agents-list-for-select';

type AiAgentsSelectProps = {
  name: string;
  selectedAiAgentId: string | undefined;
  onChange: ValueChanged<SelectOption<string> | null>;
  placeholder?: string;
  isDisabled?: boolean;
  hasError?: boolean;
};

export const AiAgentsSelect = ({ selectedAiAgentId, ...rest }: AiAgentsSelectProps) => {
  const { aiAgents, loading, loadMore, hasNextPage } = useAiAgentsListForSelect();

  const options = aiAgents.map(({ id, name }) => ({ label: name, value: id }));

  return (
    <Select
      {...rest}
      label=""
      isMulti={false}
      isSearchable={false}
      isLoading={loading}
      options={options}
      value={options.find(({ value }) => value === selectedAiAgentId) ?? null}
      canLoadMore={hasNextPage}
      onLoadMore={loadMore}
    />
  );
};
